import { Component } from '@angular/core';

@Component({
  selector: 'app-iso27001',
  imports: [],
  templateUrl: './iso27001.html',
  styleUrl: './iso27001.css',
})
export class Iso27001 {
  features = [
    {
      icon: '🌍',
      title: 'International Standard',
      description: 'Achieve globally recognized ISO 27001 certification demonstrating world-class information security management.'
    },
    {
      icon: '📊',
      title: 'ISMS Implementation',
      description: 'Build comprehensive Information Security Management System with policies, processes, and controls.'
    },
    {
      icon: '🔒',
      title: 'Risk Management',
      description: 'Systematic risk assessment and treatment methodology aligned with ISO 27001 requirements.'
    },
    {
      icon: '📝',
      title: 'Annex A Controls',
      description: 'Implementation of 114 security controls across 14 domains covering all aspects of information security.'
    },
    {
      icon: '🔄',
      title: 'Continuous Improvement',
      description: 'Plan-Do-Check-Act cycle for ongoing ISMS enhancement and security posture optimization.'
    },
    {
      icon: '✅',
      title: 'Certification Support',
      description: 'End-to-end support through certification audit process with accredited certification bodies.'
    }
  ];

  process = [
    {
      number: 1,
      title: 'Gap Analysis',
      description: 'Assess current security posture against ISO 27001 requirements and identify implementation gaps.'
    },
    {
      number: 2,
      title: 'ISMS Design',
      description: 'Design and document Information Security Management System tailored to your organization.'
    },
    {
      number: 3,
      title: 'Control Implementation',
      description: 'Deploy required security controls and establish ongoing ISMS processes and procedures.'
    },
    {
      number: 4,
      title: 'Certification Audit',
      description: 'Guide through Stage 1 and Stage 2 audits to achieve ISO 27001 certification.'
    }
  ];

  caseStudy = {
    title: 'Global Tech Company Earns ISO 27001 Certification',
    description: 'A multinational software company with operations in 15 countries needed ISO 27001 certification to meet regulatory requirements and win government contracts.',
    challenge: 'Complex multi-region operations, diverse technology stack, and tight 9-month certification deadline',
    solution: 'Centralized ISMS framework with regional adaptations, automated compliance monitoring, and accelerated implementation',
    industry: 'Technology',
    timeline: '9 Months',
    result: '$20M Contracts'
  };

  testimonial = {
    quote: 'HoneyKode navigated us through the complexity of ISO 27001 certification across multiple countries. Their expertise made what seemed impossible entirely achievable. The certification has opened doors we could not access before.',
    author: 'Alexandra Petrov',
    role: 'Global CISO, TechGlobal Systems'
  };
}
